/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CloseAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import ButtonIcon from 'DesignSystem/ButtonIcon/index'
import Label from 'DesignSystem/Label/index'
import React from 'react'
import Shortcut from 'DesignSystem/Shortcut/react'
import XIcon from 'DesignSystem/Svgs/XIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CloseAction({
  children,
  viewPath = "/App/Account/NewPatient/Content/Panes/Lead/No/Heading/CloseAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<ButtonIcon
  viewPath={`${viewPath}/ButtonIcon`}
 marginLeft={-28}
 marginRight={dtSpaceXs}
 paddingTop={dtSpaceXs}
 paddingBottom={dtSpaceXs}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../../../../../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../../../../../No'))}
>
{childProps => (
<div
  data-testid="CloseAction.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-1xAYKG': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<XIcon
  viewPath={`${viewPath}/XIcon`}
/>
<Label
  viewPath={`${viewPath}/Label`}
 marginTop={dtSpaceXs}
 text="ESC"
/>
<Shortcut
  viewPath={`${viewPath}/Shortcut`}
 keys="esc"
 type="keyup"
 onPress={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../../../../../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../../../../../No'))}
/>
</div>
)}
</ButtonIcon>
{children}
</React.Fragment>)
}